// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BeforeApproving_pCIan {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 90%;
  margin: 20px auto;
  background: var(--f9-background);
  padding: 10px;
  border-radius: 10px;

  p {
    font-size: 14px;
    color: var(--595959-color);
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.13px;
    margin: 5px ;
  }

  .draft_S_ksm {
    color: var(--_71717a-color);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.13px;
  }

  .paid_Pij6h {
    color: var(--_10a37f-background);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.13px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/BeforeApprovingPopup/BeforeApprovingPopup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;;EAEnB;IACE,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;;AAEF","sourcesContent":[".BeforeApproving {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 90%;\n  margin: 20px auto;\n  background: var(--f9-background);\n  padding: 10px;\n  border-radius: 10px;\n\n  p {\n    font-size: 14px;\n    color: var(--595959-color);\n    text-align: center;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: 0.13px;\n    margin: 5px ;\n  }\n\n  .draft {\n    color: var(--_71717a-color);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: 0.13px;\n  }\n\n  .paid {\n    color: var(--_10a37f-background);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: 0.13px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BeforeApproving": `BeforeApproving_pCIan`,
	"draft": `draft_S_ksm`,
	"paid": `paid_Pij6h`
};
export default ___CSS_LOADER_EXPORT___;
